import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { LoyaltyRouteNames, LoyaltyRoutePathNames } from '../enums';
import { beforeEnter } from './guards/index';

const CampaignList = () => import('../views/campaigns/CampaignList.vue');
const CampaignCreate = () => import('../views/campaigns/CampaignCreate.vue');
const CampaignDetail = () => import('../views/campaigns/CampaignDetail.vue');
const CampaignEdit = () => import('../views/campaigns/CampaignEdit.vue');

const VoucherList = () => import('../views/vouchers/VoucherList.vue');
const VoucherCreate = () => import('../views/vouchers/VoucherCreate.vue');
const VoucherDetail = () => import('../views/vouchers/VoucherDetail.vue');

const ProgramList = () => import('../views/programs/ProgramList.vue');
const ProgramCreate = () => import('../views/programs/ProgramCreate.vue');
const ProgramDetail = () => import('../views/programs/ProgramDetail.vue');
const ProgramEdit = () => import('../views/programs/ProgramEdit.vue');
const CardDetail = () => import('../views/programs/CardDetail.vue');

const SegmentList = () => import('../views/segments/SegmentList.vue');
const SegmentCreate = () => import('../views/segments/SegmentCreate.vue');
const SegmentDetail = () => import('../views/segments/SegmentDetail.vue');

const ReportingCampaigns = () => import('../views/reporting/ReportingCampaigns.vue');
const ReportingCustomers = () => import('../views/reporting/ReportingCustomers.vue');

// --- Campaigns ---

const campaignListRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.CAMPAIGNS, LoyaltyRoutePathNames.LIST),
  name: LoyaltyRouteNames.CAMPAIGNS_LIST,
  component: CampaignList,
  beforeEnter,
};

const campaignCreateRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.CAMPAIGNS, LoyaltyRoutePathNames.CREATE),
  name: LoyaltyRouteNames.CAMPAIGNS_CREATE,
  component: CampaignCreate,
  beforeEnter,
};

const campaignDetailRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.CAMPAIGNS, LoyaltyRoutePathNames.DETAIL),
  name: LoyaltyRouteNames.CAMPAIGNS_DETAIL,
  component: CampaignDetail,
  beforeEnter,
};

const campaignEditRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.CAMPAIGNS, LoyaltyRoutePathNames.EDIT),
  name: LoyaltyRouteNames.CAMPAIGNS_EDIT,
  component: CampaignEdit,
  beforeEnter,
};

// --- Vouchers ---

const voucherListRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.VOUCHERS, LoyaltyRoutePathNames.LIST),
  name: LoyaltyRouteNames.VOUCHERS_LIST,
  component: VoucherList,
  beforeEnter,
};

const voucherCreateRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.VOUCHERS, LoyaltyRoutePathNames.CREATE),
  name: LoyaltyRouteNames.VOUCHERS_CREATE,
  component: VoucherCreate,
  beforeEnter,
};

const voucherDetailRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.VOUCHERS, LoyaltyRoutePathNames.DETAIL),
  name: LoyaltyRouteNames.VOUCHERS_DETAIL,
  component: VoucherDetail,
  beforeEnter,
};

// --- Programs ---

const programListRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.PROGRAMS, LoyaltyRoutePathNames.LIST),
  name: LoyaltyRouteNames.PROGRAMS_LIST,
  component: ProgramList,
  beforeEnter,
};

const programCreateRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.PROGRAMS, LoyaltyRoutePathNames.CREATE),
  name: LoyaltyRouteNames.PROGRAMS_CREATE,
  component: ProgramCreate,
  beforeEnter,
};

const programDetailRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.PROGRAMS, LoyaltyRoutePathNames.DETAIL),
  name: LoyaltyRouteNames.PROGRAMS_DETAIL,
  component: ProgramDetail,
  beforeEnter,
};

const programEditRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.PROGRAMS, LoyaltyRoutePathNames.EDIT),
  name: LoyaltyRouteNames.PROGRAMS_EDIT,
  component: ProgramEdit,
  beforeEnter,
};

const cardDetailRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.PROGRAMS, LoyaltyRoutePathNames.CARD_DETAIL),
  name: LoyaltyRouteNames.PROGRAMS_CARD_DETAIL,
  component: CardDetail,
  beforeEnter,
};

// --- Segments ---

const segmentListRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.SEGMENTS, LoyaltyRoutePathNames.LIST),
  name: LoyaltyRouteNames.SEGMENTS_LIST,
  component: SegmentList,
  beforeEnter,
};

const segmentCreateRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.SEGMENTS, LoyaltyRoutePathNames.CREATE),
  name: LoyaltyRouteNames.SEGMENTS_CREATE,
  component: SegmentCreate,
  beforeEnter,
};

const segmentDetailRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.SEGMENTS, LoyaltyRoutePathNames.DETAIL),
  name: LoyaltyRouteNames.SEGMENTS_DETAIL,
  component: SegmentDetail,
  beforeEnter,
};

// --- Reporting ---

const reportingCampaignsRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.REPORTING, LoyaltyRoutePathNames.CAMPAIGNS),
  name: LoyaltyRouteNames.REPORTING_CAMPAIGNS,
  component: ReportingCampaigns,
  beforeEnter,
};

const reportingCustomersRoute: RouteRecordRaw = {
  path: buildChildURL(LoyaltyRoutePathNames.REPORTING, LoyaltyRoutePathNames.CUSTOMERS),
  name: LoyaltyRouteNames.REPORTING_CUSTOMERS,
  component: ReportingCustomers,
  beforeEnter,
};

const childRoutes: RouteRecordRaw[] = [
  campaignListRoute,
  campaignCreateRoute,
  campaignEditRoute,
  campaignDetailRoute,

  voucherListRoute,
  voucherCreateRoute,
  voucherDetailRoute,

  programListRoute,
  programCreateRoute,
  programEditRoute,
  programDetailRoute,
  cardDetailRoute,

  segmentListRoute,
  segmentCreateRoute,
  segmentDetailRoute,

  reportingCampaignsRoute,
  reportingCustomersRoute,
];

export default childRoutes;
